import { Link } from 'react-router-dom';
import { Mail, Phone, Clock } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_student-stash-1/artifacts/u55l23lh_Student%20STORE%20IT%20Logo.png";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-gray-200" data-testid="footer">
      <div className="section-container py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <div className="mb-4">
              <img
                src={LOGO_URL}
                alt="Student Store It"
                className="h-16 w-auto object-contain"
              />
            </div>
            <p className="text-gray-500 text-sm mb-4">
              Campus Storage Solutions
            </p>
            <div className="flex items-center gap-2 text-sm">
              <span className="text-navy font-semibold">Safe</span>
              <span className="tagline-dot"></span>
              <span className="text-navy font-semibold">Secure</span>
              <span className="tagline-dot"></span>
              <span className="text-navy font-semibold">Student-Focused</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-lg text-navy mb-4" style={{ fontFamily: 'Chivo, sans-serif' }}>
              Quick Links
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/how-it-works" className="text-gray-500 hover:text-navy transition-colors text-sm">
                  How It Works
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-gray-500 hover:text-navy transition-colors text-sm">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/schools" className="text-gray-500 hover:text-navy transition-colors text-sm">
                  Schools We Serve
                </Link>
              </li>
              <li>
                <Link to="/careers" className="text-gray-500 hover:text-navy transition-colors text-sm">
                  Campus Careers
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-500 hover:text-navy transition-colors text-sm">
                  Reserve Storage
                </Link>
              </li>
            </ul>
          </div>

          {/* Schools */}
          <div>
            <h4 className="font-bold text-lg text-navy mb-4" style={{ fontFamily: 'Chivo, sans-serif' }}>
              Schools We Serve
            </h4>
            <ul className="space-y-2 text-sm text-gray-500">
              <li>University of Virginia</li>
              <li>Virginia Tech</li>
              <li>George Mason University</li>
              <li>Georgetown University</li>
              <li>Duke University</li>
              <li>
                <Link to="/schools" className="text-navy font-medium hover:underline">
                  View All Schools
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold text-lg text-navy mb-4" style={{ fontFamily: 'Chivo, sans-serif' }}>
              Contact Us
            </h4>
            <ul className="space-y-4">
              <li>
                <a
                  href="tel:+15407654298"
                  className="flex items-center gap-3 text-gray-500 hover:text-navy transition-colors text-sm"
                >
                  <Phone className="w-4 h-4 flex-shrink-0 text-red-600" />
                  +1 (540) 765-4298
                </a>
              </li>
              <li>
                <a
                  href="mailto:mandy@studentstoreit.com"
                  className="flex items-center gap-3 text-gray-500 hover:text-navy transition-colors text-sm"
                >
                  <Mail className="w-4 h-4 flex-shrink-0 text-red-600" />
                  mandy@studentstoreit.com
                </a>
              </li>
              <li className="flex items-start gap-3 text-gray-500 text-sm">
                <Clock className="w-4 h-4 flex-shrink-0 mt-0.5 text-red-600" />
                <span>Mon - Sat: 9AM - 5PM</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-200 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              &copy; {currentYear} Student Store It. All rights reserved.
            </p>
            <p className="text-gray-400 text-sm">
              Powered by MTBL Group
            </p>
            <div className="flex gap-6 text-sm text-gray-400">
              <Link to="/contact" className="hover:text-navy transition-colors">
                Privacy Policy
              </Link>
              <Link to="/contact" className="hover:text-navy transition-colors">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
